import script from "./DashboardGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardGrid.vue?vue&type=script&setup=true&lang=js"

import "./DashboardGrid.vue?vue&type=style&index=0&id=7adb4831&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7adb4831"]])

export default __exports__